//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class SavedSearch extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'SavedSearch';
  }
}
SavedSearch.initClass();

export { SavedSearch };
